import { http } from './http';
import { ROUTES } from './config';
import type {
  ContactStatus,
  ContactSubmission,
  ContactSubmissionPage,
  ContactPublicSubmitRequest,
} from '../types/domain';

/**
 * ContactsController client — the manager+ triage queue for public contact-form
 * submissions, plus the anonymous public submit endpoint itself.
 */
export const contactsApi = {
  /** Anonymous — the customer-facing contact form. No auth header sent. */
  submitPublic(payload: ContactPublicSubmitRequest): Promise<void> {
    return http.post(`${ROUTES.contacts}/public`, payload, { anonymous: true });
  },

  list(status?: ContactStatus, cursor?: string, pageSize = 50): Promise<ContactSubmissionPage> {
    const params = new URLSearchParams({ pageSize: String(pageSize) });
    if (status) params.set('status', status);
    if (cursor) params.set('cursor', cursor);
    return http.get(`${ROUTES.contacts}?${params.toString()}`);
  },

  get(id: string): Promise<ContactSubmission> {
    return http.get(`${ROUTES.contacts}/${id}`);
  },

  /** rowVersion enables optimistic concurrency — a stale value 409s instead of clobbering. */
  setStatus(id: string, status: ContactStatus, rowVersion?: number): Promise<void> {
    return http.put(`${ROUTES.contacts}/${id}/status`, { status, rowVersion });
  },

  remove(id: string): Promise<void> {
    return http.delete(`${ROUTES.contacts}/${id}`);
  },
};
